export default __webpack_public_path__ + "static/media/Rojevas-White.8a338ad5.svg";